import * as App from 'app-path';

export default App.default;
export const clientApolloSchema = App.clientApolloSchema || {};
